import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  private URL = environment.api + "api/erp/purchase/invoices";
  constructor(
    private http: HttpClient,
  ) { }

  getExchangeDollar(date: any){
    return this.http.get(this.URL + `/currency-by-date`, {
      params: {
        startDate: date
      }
    });
  }
}
